// extracted by mini-css-extract-plugin
module.exports = {"lynxScreenBlue":"#27aae1","progressColor":"#aaa","singingBlue":"#0375a3","primaryColor":"#0375a3"};